<template>
  <main class="mall_main" :style="mainLayoutStyle">
    <ContentsMallHeader
      ref="headerRef"
      :categoryList="categoryList"
      :categoryList2="categoryList2"
      :activeCategory="activeCategory"
      v-model:selectedCategoryId="selectedCategoryId"
      v-model:searchQuery="searchQuery"
      @search="handleSearch"
      @getSubCategories="getSubCategories"
      @hideSubCategories="hideSubCategories"
    />

    <div class="max-w-[82.75rem] mt-14 mx-auto">
      <!-- 하나 바이블 콘텐츠 추천 -->
      <div
        class="relative flex items-center justify-center max-md:flex-col gap-y-2"
      >
        <!-- 이전 -->
        <button
          class="max-md:hidden border border-neutral-900 text-neutral-900 rounded-full p-2 mr-10"
          @click="moveSelection(-1)"
        >
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M13 5.18395C13.0009 5.34201 12.9714 5.4987 12.9132 5.64503C12.855 5.79136 12.7692 5.92445 12.6609 6.03667L8.79007 9.98799L12.5088 13.9513C12.7266 14.1763 12.8489 14.4807 12.8489 14.798C12.8489 15.1153 12.7266 15.4197 12.5088 15.6447C12.4001 15.7573 12.2708 15.8467 12.1283 15.9076C11.9858 15.9686 11.8329 16 11.6785 16C11.5242 16 11.3713 15.9686 11.2288 15.9076C11.0863 15.8467 10.957 15.7573 10.8482 15.6447L6.33429 10.8407C6.12002 10.6162 6 10.3144 6 10C6 9.68563 6.12002 9.3838 6.33429 9.15929L11.012 4.35526C11.1207 4.24269 11.25 4.15334 11.3925 4.09237C11.535 4.03139 11.6879 4 11.8423 4C11.9966 4 12.1495 4.03139 12.292 4.09237C12.4345 4.15334 12.5638 4.24269 12.6725 4.35526C12.8815 4.5779 12.9988 4.87473 13 5.18395Z"
              fill="currentColor"
            />
          </svg>
        </button>

        <ul
          class="w-[40rem] max-w-full md:max-w-[92%] flex max-md:flex-col items-center justify-center gap-2 px-2"
        >
          <!-- 부서 선택 -->
          <li class="relative w-full">
            <button
              @click="isDepartmentPopoverOpen = !isDepartmentPopoverOpen"
              :class="[
                'w-full flex items-center justify-center gap-x-2 border border-neutral-100 px-3 py-1.5 rounded-full hover:bg-white transition-colors max-md:text-sm whitespace-nowrap',
                selectedCategory
                  ? 'border-blue-500 text-blue-600 font-semibold bg-blue-50'
                  : 'bg-neutral-100 text-neutral-700',
              ]"
            >
              {{
                selectedCategory
                  ? getCategoryLabel(selectedCategory)
                  : "1. 부서 선택"
              }}
              <svg
                width="10"
                height="5"
                viewBox="0 0 10 5"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                :class="{ 'rotate-180': isDepartmentPopoverOpen }"
              >
                <path
                  d="M0 0.550314L5 5L10 0.550314L9.37279 0L5 3.89151L0.627209 0L0 0.550314Z"
                  fill="currentColor"
                />
              </svg>
            </button>

            <div v-if="isDepartmentPopoverOpen" class="popover_container">
              <b class="md:hidden text-lg font-semibold mb-3">부서 선택</b>
              <button
                @click="isDepartmentPopoverOpen = false"
                class="absolute top-4 md:top-2 right-4 md:right-3 p-1 z-10"
              >
                <svg
                  width="12"
                  height="12"
                  viewBox="0 0 12 12"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M6.59966 5.9976L11.1021 1.4908C11.1815 1.41097 11.226 1.30292 11.226 1.19031C11.2259 1.0777 11.1812 0.969714 11.1017 0.889996C10.9425 0.731596 10.6621 0.730796 10.5013 0.890796L6.00006 5.3976L1.49726 0.889596C1.33726 0.731596 1.05686 0.732396 0.897657 0.890396C0.858142 0.929753 0.826861 0.976587 0.80564 1.02816C0.784419 1.07974 0.773683 1.13503 0.774057 1.1908C0.774057 1.3044 0.818057 1.4108 0.897657 1.4896L5.40006 5.9972L0.898057 10.5052C0.818611 10.5851 0.774121 10.6933 0.774346 10.806C0.774571 10.9188 0.819493 11.0268 0.899257 11.1064C0.976457 11.1828 1.08566 11.2268 1.19846 11.2268H1.20086C1.31406 11.2264 1.42326 11.182 1.49886 11.1048L6.00006 6.598L10.5029 11.106C10.5825 11.1852 10.6889 11.2292 10.8017 11.2292C10.8574 11.2293 10.9126 11.2183 10.9641 11.197C11.0156 11.1757 11.0625 11.1444 11.1019 11.105C11.1413 11.0656 11.1725 11.0188 11.1939 10.9673C11.2152 10.9158 11.2261 10.8605 11.2261 10.8048C11.2261 10.6916 11.1821 10.5848 11.1021 10.506L6.59966 5.9976Z"
                    fill="currentColor"
                  />
                </svg>
              </button>
              <div class="relative py-1 flex flex-col w-full">
                <!-- 카테고리 섹션 -->
                <div class="flex-grow flex-shrink-0">
                  <label
                    class="min-w-40 flex items-center md:px-4 py-2 text-sm hover:bg-neutral-50 cursor-pointer"
                  >
                    <input
                      type="radio"
                      value=""
                      v-model="selectedCategory"
                      class="mr-2"
                      @change="handleListChange"
                    />
                    선택 안 함
                  </label>
                  <label
                    v-for="category in groups"
                    :key="category.value"
                    class="min-w-40 flex items-center md:px-4 py-2 text-sm hover:bg-neutral-50 cursor-pointer"
                  >
                    <input
                      type="radio"
                      :value="category.value"
                      v-model="selectedCategory"
                      class="mr-2"
                      @change="handleListChange"
                    />
                    {{ category.label }}
                  </label>
                </div>
              </div>
            </div>
          </li>

          <!-- 학기,과정 선택 -->
          <li class="relative w-full">
            <button
              @click="isSemesterPopoverOpen = !isSemesterPopoverOpen"
              :class="[
                'w-full flex items-center justify-center gap-x-2 border border-neutral-100 px-3 py-1.5 rounded-full hover:bg-white transition-colors max-md:text-sm whitespace-nowrap',
                selectedSemester
                  ? 'border-blue-500 text-blue-600 font-semibold bg-blue-50'
                  : 'bg-neutral-100 text-neutral-700',
              ]"
            >
              {{
                selectedSemester
                  ? getSemesterLabel(selectedSemester)
                  : "2. 학기/과정 선택"
              }}
              <svg
                width="10"
                height="5"
                viewBox="0 0 10 5"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                :class="{ 'rotate-180': isSemesterPopoverOpen }"
              >
                <path
                  d="M0 0.550314L5 5L10 0.550314L9.37279 0L5 3.89151L0.627209 0L0 0.550314Z"
                  fill="currentColor"
                />
              </svg>
            </button>

            <div v-if="isSemesterPopoverOpen" class="popover_container">
              <b class="md:hidden text-lg font-semibold mb-3">학기/과정 선택</b>
              <button
                @click="isSemesterPopoverOpen = false"
                class="absolute top-4 md:top-2 right-4 md:right-3 p-1 z-10"
              >
                <svg
                  width="12"
                  height="12"
                  viewBox="0 0 12 12"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M6.59966 5.9976L11.1021 1.4908C11.1815 1.41097 11.226 1.30292 11.226 1.19031C11.2259 1.0777 11.1812 0.969714 11.1017 0.889996C10.9425 0.731596 10.6621 0.730796 10.5013 0.890796L6.00006 5.3976L1.49726 0.889596C1.33726 0.731596 1.05686 0.732396 0.897657 0.890396C0.858142 0.929753 0.826861 0.976587 0.80564 1.02816C0.784419 1.07974 0.773683 1.13503 0.774057 1.1908C0.774057 1.3044 0.818057 1.4108 0.897657 1.4896L5.40006 5.9972L0.898057 10.5052C0.818611 10.5851 0.774121 10.6933 0.774346 10.806C0.774571 10.9188 0.819493 11.0268 0.899257 11.1064C0.976457 11.1828 1.08566 11.2268 1.19846 11.2268H1.20086C1.31406 11.2264 1.42326 11.182 1.49886 11.1048L6.00006 6.598L10.5029 11.106C10.5825 11.1852 10.6889 11.2292 10.8017 11.2292C10.8574 11.2293 10.9126 11.2183 10.9641 11.197C11.0156 11.1757 11.0625 11.1444 11.1019 11.105C11.1413 11.0656 11.1725 11.0188 11.1939 10.9673C11.2152 10.9158 11.2261 10.8605 11.2261 10.8048C11.2261 10.6916 11.1821 10.5848 11.1021 10.506L6.59966 5.9976Z"
                    fill="black"
                  />
                </svg>
              </button>
              <div
                class="relative py-1 flex flex-col w-full h-full overflow-auto"
              >
                <!-- 카테고리 섹션 -->
                <div
                  class="flex-grow flex-shrink-0 max-h-screen md:max-h-[30vh] overflow-auto"
                >
                  <label
                    class="min-w-40 flex items-center md:px-4 py-2 text-sm hover:bg-neutral-50 cursor-pointer"
                  >
                    <input
                      type="radio"
                      value=""
                      v-model="selectedSemester"
                      class="mr-2"
                      @change="handleSemesterChange"
                    />
                    선택 안 함
                  </label>
                  <label
                    v-for="semester in semesters"
                    :key="semester.value"
                    class="min-w-40 flex items-center md:px-4 py-2 text-sm hover:bg-neutral-50 cursor-pointer"
                  >
                    <input
                      type="radio"
                      :value="semester.value"
                      v-model="selectedSemester"
                      class="mr-2"
                      @change="handleSemesterChange"
                    />
                    {{ semester.label }}
                  </label>
                </div>
              </div>
            </div>
          </li>

          <!-- 과 선택 -->
          <li class="relative w-full">
            <button
              @click="isChapterPopoverOpen = !isChapterPopoverOpen"
              :class="[
                'w-full flex items-center justify-center gap-x-2 border border-neutral-100 px-3 py-1.5 rounded-full hover:bg-white transition-colors max-md:text-sm whitespace-nowrap',
                selectedLesson
                  ? 'border-blue-500 text-blue-600 font-semibold bg-blue-50'
                  : 'bg-neutral-100 text-neutral-700',
              ]"
            >
              {{
                selectedLesson ? getChapterLabel(selectedLesson) : "3. 과 선택"
              }}
              <svg
                width="10"
                height="5"
                viewBox="0 0 10 5"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                :class="{ 'rotate-180': isChapterPopoverOpen }"
              >
                <path
                  d="M0 0.550314L5 5L10 0.550314L9.37279 0L5 3.89151L0.627209 0L0 0.550314Z"
                  fill="black"
                />
              </svg>
            </button>

            <div v-if="isChapterPopoverOpen" class="popover_container">
              <b class="md:hidden text-lg font-semibold mb-3">과 선택</b>
              <button
                @click="isChapterPopoverOpen = false"
                class="absolute top-4 md:top-2 right-4 md:right-3 p-1 z-10"
              >
                <svg
                  width="12"
                  height="12"
                  viewBox="0 0 12 12"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M6.59966 5.9976L11.1021 1.4908C11.1815 1.41097 11.226 1.30292 11.226 1.19031C11.2259 1.0777 11.1812 0.969714 11.1017 0.889996C10.9425 0.731596 10.6621 0.730796 10.5013 0.890796L6.00006 5.3976L1.49726 0.889596C1.33726 0.731596 1.05686 0.732396 0.897657 0.890396C0.858142 0.929753 0.826861 0.976587 0.80564 1.02816C0.784419 1.07974 0.773683 1.13503 0.774057 1.1908C0.774057 1.3044 0.818057 1.4108 0.897657 1.4896L5.40006 5.9972L0.898057 10.5052C0.818611 10.5851 0.774121 10.6933 0.774346 10.806C0.774571 10.9188 0.819493 11.0268 0.899257 11.1064C0.976457 11.1828 1.08566 11.2268 1.19846 11.2268H1.20086C1.31406 11.2264 1.42326 11.182 1.49886 11.1048L6.00006 6.598L10.5029 11.106C10.5825 11.1852 10.6889 11.2292 10.8017 11.2292C10.8574 11.2293 10.9126 11.2183 10.9641 11.197C11.0156 11.1757 11.0625 11.1444 11.1019 11.105C11.1413 11.0656 11.1725 11.0188 11.1939 10.9673C11.2152 10.9158 11.2261 10.8605 11.2261 10.8048C11.2261 10.6916 11.1821 10.5848 11.1021 10.506L6.59966 5.9976Z"
                    fill="black"
                  />
                </svg>
              </button>

              <div
                class="relative py-1 flex w-full h-full overflow-auto max-md:pb-5"
              >
                <!-- 카테고리 섹션 -->
                <div
                  class="flex-grow flex-shrink-0 max-h-screen md:max-h-[30vh] overflow-auto"
                >
                  <label
                    class="min-w-40 flex items-center md:px-4 py-2 text-sm hover:bg-neutral-50 cursor-pointer"
                  >
                    <input
                      type="radio"
                      value=""
                      v-model="selectedLesson"
                      class="mr-2"
                      @change="handleListChange"
                    />
                    선택 안 함
                  </label>
                  <label
                    v-for="chapter in filteredLessons"
                    :key="chapter.value"
                    class="min-w-40 flex items-center md:px-4 py-2 text-sm hover:bg-neutral-50 cursor-pointer"
                  >
                    <input
                      type="radio"
                      :value="chapter.value"
                      v-model="selectedLesson"
                      class="mr-2"
                      @change="handleListChange"
                    />
                    {{ chapter.label }}
                  </label>
                </div>
              </div>
            </div>
          </li>
        </ul>

        <!-- 저장 : 비회원은 이용 불가 -->
        <button
          v-if="$store.state.uid.id"
          class="group flex items-center self-end text-sm bg-neutral-800 text-neutral-100 rounded-full px-3 py-2 whitespace-nowrap max-md:mr-2"
          @click="putPreference"
        >
          <svg
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M14 3.11111V12.4444C14 12.8722 13.8478 13.2386 13.5434 13.5434C13.2391 13.8483 12.8727 14.0005 12.4444 14H1.55556C1.12778 14 0.761704 13.8478 0.457333 13.5434C0.152963 13.2391 0.000518519 12.8727 0 12.4444V1.55556C0 1.12778 0.152445 0.761704 0.457333 0.457333C0.762222 0.152963 1.1283 0.000518518 1.55556 0H10.8889L14 3.11111ZM7 11.6667C7.64815 11.6667 8.19907 11.4398 8.65278 10.9861C9.10648 10.5324 9.33333 9.98148 9.33333 9.33333C9.33333 8.68518 9.10648 8.13426 8.65278 7.68055C8.19907 7.22685 7.64815 7 7 7C6.35185 7 5.80093 7.22685 5.34722 7.68055C4.89352 8.13426 4.66667 8.68518 4.66667 9.33333C4.66667 9.98148 4.89352 10.5324 5.34722 10.9861C5.80093 11.4398 6.35185 11.6667 7 11.6667ZM2.33333 5.44444H9.33333V2.33333H2.33333V5.44444Z"
              fill="currentColor"
            />
          </svg>

          <p
            class="md:opacity-0 md:max-w-0 overflow-hidden transition-all duration-700 ease-in-out group-hover:opacity-100 group-hover:max-w-[200px]"
          >
            &nbsp;설정 저장하기
          </p>
        </button>

        <!-- 다음 -->
        <button
          class="max-md:hidden border border-neutral-900 text-neutral-900 rounded-full p-2 ml-10"
          @click="moveSelection(1)"
        >
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M6.00002 14.816C5.99913 14.658 6.02863 14.5013 6.08682 14.355C6.14502 14.2086 6.23077 14.0756 6.33915 13.9633L10.2099 10.012L6.49118 6.04868C6.27337 5.82366 6.15112 5.51926 6.15112 5.20197C6.15112 4.88468 6.27337 4.58028 6.49118 4.35526C6.59989 4.24269 6.72923 4.15334 6.87173 4.09237C7.01424 4.03139 7.16709 4 7.32146 4C7.47584 4 7.62869 4.03139 7.7712 4.09237C7.9137 4.15334 8.04304 4.24269 8.15175 4.35526L12.6657 9.15929C12.88 9.3838 13 9.68563 13 10C13 10.3144 12.88 10.6162 12.6657 10.8407L7.98803 15.6447C7.87932 15.7573 7.74998 15.8467 7.60748 15.9076C7.46497 15.9686 7.31212 16 7.15775 16C7.00337 16 6.85052 15.9686 6.70801 15.9076C6.56551 15.8467 6.43617 15.7573 6.32746 15.6447C6.1185 15.4221 6.00122 15.1253 6.00002 14.816Z"
              fill="currentColor"
            />
          </svg>
        </button>
      </div>

      <div class="relative flex justify-center mt-4">
        <div
          @click="isTipVisible = !isTipVisible"
          class="inline-flex items-center gap-1 bg-blue-50 text-blue-600 rounded-full px-3 py-1 cursor-pointer"
        >
          <span class="text-sm font-medium">{{ smartRecommendationText }}</span>
          <button
            class="w-4 h-4 rounded-full bg-blue-200 text-blue-700 text-xs flex items-center justify-center hover:bg-blue-300 transition-colors"
          >
            ?
          </button>
        </div>
        <!-- 툴팁 -->
        <Transition name="fade">
          <div
            v-if="isTipVisible"
            class="tip-wrapper absolute bottom-[calc(100%+10px)] z-10 bg-white p-5 rounded-lg shadow-xl border border-gray-200 max-w-[40rem] text-sm text-left break-keep"
          >
            <button
              @click="closeTip"
              class="absolute top-3 right-3 text-gray-400 hover:text-black transition-colors"
              aria-label="닫기"
            >
              <svg
                width="12"
                height="12"
                viewBox="0 0 14 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M1 1L13 13M1 13L13 1"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </button>

            <div class="pr-2">
              <b class="block text-base mb-2 text-blue-600">
                스마트 추천 기능
              </b>

              <p>
                회원님께서 입력해주신 부서와 교육 과정 정보를 바탕으로, 지금 이
                영역에는 회원님께 가장 필요하고 적합한 콘텐츠만 모아 보여드리고
                있습니다.<br />
                플랫폼의 <b>AI 추천 시스템</b>이 회원님의 교육 환경에 맞춰
                <b>가장 시의적절한 하나 바이블 영상</b>을 자동으로 선별해
                드립니다.<br /><br />
              </p>

              <b>
                부서/과정 정보를 수정하고 싶으신가요?
                <router-link to="/mypage" class="underline"
                  >[마이페이지 바로가기]</router-link
                >
              </b>
            </div>

            <div
              class="absolute -bottom-2 left-1/2 -translate-x-1/2 w-4 h-4 bg-white border-b border-r border-gray-200 rotate-45"
            ></div>
          </div>
        </Transition>
      </div>

      <!-- 콘텐츠 목록 -->
      <div
        v-if="loading === false && contentList && contentList.length > 0"
        class="mt-10"
      >
        <menu class="product_grid_container">
          <li
            v-for="content in contentList"
            :key="content.id"
            class="product_grid_wr relative"
            @mouseover="hoveredItem = content.id"
            @mouseleave="hoveredItem = null"
          >
            <!-- thumb -->
            <div class="product_thumb mb-2">
              <button
                class="w-full h-full"
                type="button"
                @click="openContentDetail(content)"
              >
                <img
                  v-if="resolveThumbnail(content)"
                  :src="resolveThumbnail(content)"
                  :alt="content.title || content.name"
                />
                <img
                  v-else
                  src="@/assets/img/null_img.jpg"
                  :alt="content.title || content.name"
                />
              </button>
            </div>

            <!-- 상품설명 -->
            <div class="product_desc">
              <button
                type="button"
                class="product_tt text-left font-medium"
                @click="openContentDetail(content)"
              >
                {{ content.title }}
              </button>

              <!-- 마우스오버 후 -->
              <div
                class="max-sm:none absolute top-0 left-[50%] w-[calc(100%+4rem)] min-h-fit h-full p-4 rounded-xl border border-neutral-200 shadow-lg bg-white opacity-0 transition-opacity duration-300 translate-x-[-50%]"
                :class="
                  hoveredItem == content.id
                    ? 'opacity-100 z-20'
                    : 'z-10 pointer-events-none'
                "
              >
                <div
                  class="w-full h-full min-h-fit flex flex-col justify-between"
                >
                  <button @click="openContentDetail(content)" class="flex-grow">
                    <p class="leading-tight text-left mb-1">
                      {{ content.title }}
                    </p>

                    <!-- 타겟그룹 -->
                    <div
                      v-if="
                        content.targetGroupList &&
                        content.targetGroupList.length > 0
                      "
                      class="mt-4"
                    >
                      <div class="flex gap-2 items-start">
                        <svg
                          width="14"
                          height="14"
                          viewBox="0 0 14 14"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                          class="shrink-0 mt-[2px]"
                        >
                          <path
                            d="M4.66663 5.33366H4.67329M8.66663 5.33366H8.67329M4.99996 8.66699C5.21721 8.88872 5.47653 9.06488 5.76271 9.18513C6.0489 9.30539 6.3562 9.36733 6.66663 9.36733C6.97705 9.36733 7.28436 9.30539 7.57054 9.18513C7.85673 9.06488 8.11604 8.88872 8.33329 8.66699M0.666626 6.66699C0.666626 7.45492 0.82182 8.23514 1.12335 8.96309C1.42488 9.69105 1.86683 10.3525 2.42399 10.9096C2.98114 11.4668 3.64257 11.9087 4.37053 12.2103C5.09848 12.5118 5.87869 12.667 6.66663 12.667C7.45456 12.667 8.23477 12.5118 8.96273 12.2103C9.69068 11.9087 10.3521 11.4668 10.9093 10.9096C11.4664 10.3525 11.9084 9.69105 12.2099 8.96309C12.5114 8.23514 12.6666 7.45492 12.6666 6.66699C12.6666 5.87906 12.5114 5.09885 12.2099 4.37089C11.9084 3.64294 11.4664 2.9815 10.9093 2.42435C10.3521 1.8672 9.69068 1.42524 8.96273 1.12372C8.23477 0.822187 7.45456 0.666992 6.66663 0.666992C5.87869 0.666992 5.09848 0.822187 4.37053 1.12372C3.64257 1.42524 2.98114 1.8672 2.42399 2.42435C1.86683 2.9815 1.42488 3.64294 1.12335 4.37089C0.82182 5.09885 0.666626 5.87906 0.666626 6.66699Z"
                            stroke="#0059FF"
                            stroke-width="1.33333"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>

                        <div
                          class="grid gap-y-1 text-base text-gray-700 text-left"
                        >
                          <div
                            v-for="(batch, index) in getGroupedTargets(
                              content.targetGroupList,
                            )"
                            :key="index"
                            class="leading-tight"
                          >
                            <span class="font-semibold text-black">{{
                              batch.names
                            }}</span
                            >{{ batch.suffix }}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div
                      v-if="
                        content.itemUsageContextList &&
                        content.itemUsageContextList.length > 0
                      "
                      class="mt-4"
                    >
                      <div class="flex gap-2 items-start">
                        <svg
                          width="10"
                          height="14"
                          viewBox="0 0 10 14"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                          class="shrink-0 mt-[2px]"
                        >
                          <path
                            d="M4.85714 0C7.53971 0 9.71429 2 9.71429 5.42857C9.71429 6.78971 8.94886 8.46571 8.02571 9.99257L7.87057 10.2454C7.81819 10.3292 7.76571 10.4125 7.71314 10.4951L7.55371 10.7411L7.47371 10.8626L7.31343 11.1023L7.15257 11.3366L6.99257 11.566L6.83371 11.7894L6.67657 12.0066L6.52171 12.2166L6.37 12.4194L6.22171 12.6143L6.00771 12.8914L5.80543 13.148L5.61686 13.3829L5.55771 13.456C5.17086 13.9143 4.52143 13.896 4.15686 13.456L3.97343 13.2291L3.77571 12.9794L3.63657 12.8014L3.49286 12.6146L3.26914 12.3191L3.11571 12.1126L2.95971 11.8991L2.80171 11.6789L2.642 11.4526L2.48143 11.2206L2.32086 10.9834C2.26752 10.9034 2.21419 10.8228 2.16086 10.7414L2.00143 10.4957L1.844 10.2457L1.68886 9.99286C0.765428 8.46571 0 6.78971 0 5.42857C0 2 2.17457 0 4.85714 0ZM4.85714 1.14286C2.67943 1.14286 1.14286 2.76629 1.14286 5.42857C1.14286 6.38429 1.64171 7.66057 2.46 9.07057L2.60371 9.31343L2.75314 9.55886L2.90857 9.80657L2.98829 9.93114L3.152 10.1814L3.32114 10.4337L3.49543 10.6874L3.67457 10.9423L3.85857 11.1983L3.95229 11.3269L4.14314 11.584L4.316 11.8123L4.40514 11.928C4.45855 11.997 4.52703 12.0528 4.60536 12.0912C4.68368 12.1297 4.76976 12.1496 4.857 12.1496C4.94424 12.1496 5.03032 12.1297 5.10864 12.0912C5.18697 12.0528 5.25546 11.997 5.30886 11.928L5.47114 11.7166L5.66429 11.4583L5.85314 11.2011L6.03743 10.9449L6.21714 10.6894L6.39143 10.4354C6.44895 10.351 6.50543 10.2669 6.56086 10.1829L6.72486 9.93229C6.85933 9.72391 6.98771 9.51781 7.11 9.314L7.25343 9.07114C8.07286 7.66 8.57143 6.38371 8.57143 5.42857C8.57143 2.76629 7.03486 1.14286 4.85714 1.14286ZM4.85714 2.57143C5.46335 2.57143 6.04473 2.81224 6.47339 3.2409C6.90204 3.66955 7.14286 4.25093 7.14286 4.85714C7.14286 5.46335 6.90204 6.04473 6.47339 6.47339C6.04473 6.90204 5.46335 7.14286 4.85714 7.14286C4.25093 7.14286 3.66955 6.90204 3.2409 6.47339C2.81224 6.04473 2.57143 5.46335 2.57143 4.85714C2.57143 4.25093 2.81224 3.66955 3.2409 3.2409C3.66955 2.81224 4.25093 2.57143 4.85714 2.57143ZM4.85714 3.71429C4.55404 3.71429 4.26335 3.83469 4.04902 4.04902C3.83469 4.26335 3.71429 4.55404 3.71429 4.85714C3.71429 5.16025 3.83469 5.45094 4.04902 5.66526C4.26335 5.87959 4.55404 6 4.85714 6C5.16025 6 5.45094 5.87959 5.66526 5.66526C5.87959 5.45094 6 5.16025 6 4.85714C6 4.55404 5.87959 4.26335 5.66526 4.04902C5.45094 3.83469 5.16025 3.71429 4.85714 3.71429Z"
                            fill="#0059FF"
                          />
                        </svg>

                        <div
                          class="grid gap-y-1 text-base text-gray-700 text-left"
                        >
                          <p
                            v-for="(ctx, index) in content.itemUsageContextList"
                            :key="index"
                            class="leading-tight"
                          >
                            <span class="font-semibold text-black">{{
                              ctx.name
                            }}</span
                            >에서 사용해요
                          </p>
                        </div>
                      </div>
                    </div>

                    <div
                      v-if="
                        content.itemEducationInfoList &&
                        content.itemEducationInfoList.length > 0
                      "
                      class="mt-4"
                    >
                      <div class="flex gap-2 items-start">
                        <svg
                          width="13"
                          height="16"
                          viewBox="0 0 13 16"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                          class="shrink-0 mt-[2px]"
                        >
                          <path
                            d="M6.51313 7.45756C5.65827 6.82556 4.37713 5.72042 0.703983 5.72042V13.6336C4.37713 13.6336 5.65827 14.7387 6.51313 15.3707M6.51313 7.45756V15.3707M6.51313 7.45756C7.36798 6.82556 8.64913 5.72042 12.3223 5.72042V13.6336C8.64913 13.6336 7.36798 14.7387 6.51313 15.3707M8.78284 0.633559V3.41299M10.8137 0.571845H3.18284C2.96964 0.571585 2.76063 0.630965 2.57941 0.743273L0.571411 1.99356L2.57941 3.24156C2.76063 3.35387 2.96964 3.41325 3.18284 3.41299H10.8137C11.0036 3.41837 11.1926 3.38563 11.3696 3.31669C11.5466 3.24775 11.7079 3.14402 11.8441 3.01163C11.9803 2.87924 12.0886 2.72087 12.1625 2.54591C12.2365 2.37095 12.2746 2.18293 12.2746 1.99299C12.2746 1.80304 12.2365 1.61503 12.1625 1.44007C12.0886 1.2651 11.9803 1.10674 11.8441 0.974347C11.7079 0.841955 11.5466 0.738222 11.3696 0.669283C11.1926 0.600345 11.0036 0.566458 10.8137 0.571845Z"
                            stroke="#0059FF"
                            stroke-width="1.14286"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>

                        <div class="text-base text-gray-700">
                          <p
                            v-for="(
                              edu, index
                            ) in content.itemEducationInfoList"
                            :key="index"
                            class="leading-tight text-left"
                          >
                            {{ edu.curriculumSeries }}
                            {{ edu.curriculumSeason }} -
                            <span class="font-semibold text-black">{{
                              edu.itemTitle
                            }}</span>
                          </p>
                        </div>
                      </div>
                    </div>

                    <div
                      v-if="
                        content.itemKeywordList &&
                        content.itemKeywordList.length > 0
                      "
                      class="mt-4 flex-wrap gap-1"
                    >
                      <div class="flex flex-wrap gap-1 items-start">
                        <p
                          v-for="(kw, index) in content.itemKeywordList"
                          :key="index"
                          class="text-sm text-gray-700 px-2 py-1 border border-neutral-400 rounded-full leading-tight flex-shrink-0"
                        >
                          {{ formatKeyword(kw) }}
                        </p>
                      </div>
                    </div>
                  </button>

                  <!-- 하단 버튼 -->
                  <div class="flex items-center gap-1 mt-4">
                    <button
                      type="button"
                      @click="openContentDetail(content)"
                      class="p-3 rounded-lg border border-neutral-200 flex-grow text-center hover:bg-neutral-50 transition-colors"
                    >
                      자세히 보기
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </li>
        </menu>

        <pagination
          v-if="pageInfo.page"
          :pageInfo="pageInfo"
          :page="page"
          :size="size"
          @updatePage="updatePage"
        />
      </div>

      <div
        v-else-if="
          loading === false && (!contentList || contentList.length === 0)
        "
        class="text-center mt-10 py-10"
      >
        <p class="text-gray-500">콘텐츠가 없습니다.</p>
      </div>
    </div>
  </main>

  <!-- 콘텐츠 상세 모달 -->
  <div
    v-if="isDetailModalOpen"
    class="fixed inset-0 z-50 flex items-center justify-center"
  >
    <div class="absolute inset-0 bg-black/60" @click="closeDetailModal"></div>
    <div
      class="relative z-10 w-full max-w-[70.5rem] mx-4 bg-white rounded-2xl shadow-xl overflow-hidden"
    >
      <div
        class="flex items-center justify-end border-b border-neutral-200 md:p-4 p-2"
      >
        <button
          type="button"
          class="text-neutral-400 hover:text-neutral-700"
          @click="closeDetailModal"
        >
          <span class="sr-only">닫기</span>
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M4.062 4.062a.875.875 0 0 1 1.237 0L10 8.763l4.701-4.701a.875.875 0 1 1 1.237 1.237L11.237 10l4.701 4.701a.875.875 0 0 1-1.237 1.237L10 11.237l-4.701 4.701a.875.875 0 1 1-1.237-1.237L8.763 10 4.062 5.299a.875.875 0 0 1 0-1.237Z"
              fill="currentColor"
            />
          </svg>
        </button>
      </div>

      <div class="max-h-[70vh] overflow-y-auto">
        <div
          v-if="detailLoading"
          class="flex justify-center py-10 text-center text-neutral-500"
        >
          <svg
            class="mr-3 -ml-1 size-5 animate-spin text-blue-500"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
          >
            <circle
              class="opacity-25"
              cx="12"
              cy="12"
              r="10"
              stroke="currentColor"
              stroke-width="4"
            ></circle>
            <path
              class="opacity-75"
              fill="currentColor"
              d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
            ></path>
          </svg>
        </div>
        <div v-else-if="detailError" class="py-10 text-center text-red-400">
          {{ detailError }}
        </div>

        <div v-else-if="selectedContentDetail" class="space-y-6">
          <section
            v-for="section in selectedContentDetail"
            :key="section.videoId"
          >
            <template v-if="section.videoLinkNormal">
              <iframe
                v-if="getVideoInfo(section.videoLinkNormal).type === 'youtube'"
                :src="getVideoInfo(section.videoLinkNormal).src"
                frameborder="0"
                allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share"
                referrerpolicy="strict-origin-when-cross-origin"
                allowfullscreen
                style="width: 100%; height: auto; aspect-ratio: 16 / 9"
              ></iframe>

              <div
                v-else-if="
                  getVideoInfo(section.videoLinkNormal).type === 'vimeo'
                "
              >
                <iframe
                  :src="getVideoInfo(section.videoLinkNormal).src"
                  frameborder="0"
                  allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share"
                  referrerpolicy="strict-origin-when-cross-origin"
                  allowfullscreen
                  style="width: 100%; height: auto; aspect-ratio: 16 / 9"
                ></iframe>
              </div>

              <iframe
                v-else
                :src="section.videoLinkNormal"
                allowfullscreen
                style="width: 100%; height: auto; aspect-ratio: 16 / 9"
              ></iframe>
            </template>
          </section>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { onMounted, ref, watchEffect, onUnmounted, computed } from "vue";
import axios from "axios";
import router from "@/router";
import { useRoute } from "vue-router";
import ContentsMallHeader from "@/components/ContentsMallHeader.vue";
import Pagination from "@/components/Pagination.vue";

const route = useRoute();

const categoryList = ref([]);
const categoryList2 = ref([]);
const activeCategory = ref(null);
const subCategoriesMap = ref(new Map());
const lastHoveredCategory = ref(null);

const searchQuery = ref("");
const selectedCategoryId = ref("");
const headerRef = ref(null);
const DEFAULT_NAV_HEIGHT = 80;
const navHeight = ref(0);

const isDepartmentPopoverOpen = ref(false);
const isSemesterPopoverOpen = ref(false);
const isChapterPopoverOpen = ref(false);

const selectedCategory = ref("");
const selectedSemester = ref("");
const selectedLesson = ref("");

const loading = ref(false);
const contentList = ref([]);
const hoveredItem = ref(null);

const isDetailModalOpen = ref(false);
const detailLoading = ref(false);
const detailError = ref("");
const selectedContentDetail = ref(null);

const hanaBiblePreference = ref("");
const isTipVisible = ref(false);

const smartRecommendationText = computed(() => {
  if (
    selectedCategory.value ||
    selectedSemester.value ||
    selectedLesson.value
  ) {
    return "스마트 추천 기능 적용 중";
  } else {
    return "스마트 추천을 위해 정보를 설정해주세요";
  }
});

const pageInfo = ref({});
const page = ref(1);
const size = ref(15);

const mainLayoutStyle = computed(() => {
  const height = navHeight.value || DEFAULT_NAV_HEIGHT;
  return {
    minHeight: `calc(100vh - ${height}px)`,
    marginTop: `${height}px`,
  };
});

const closeDetailModal = () => {
  isDetailModalOpen.value = false;
  selectedContentDetail.value = null;
  detailError.value = "";
};

const handleKeyDown = (event) => {
  if (event.key === "Escape" && isDetailModalOpen.value) {
    closeDetailModal();
  }
};

const resolveThumbnail = (content) => {
  const thumb =
    content?.thumbnailLink || content?.thumb || content?.thumbnail || "";

  if (!thumb) {
    return null;
  }

  if (/^https?:\/\//i.test(thumb)) {
    return thumb;
  }

  return `https://eduwind-api.nodeblack.net/${thumb}`;
};

// 하나 바이블 API baseUrl
const AppBibleAPIGroup = {
  baseUrl: "http://118.67.134.110:18080",
};

// 카테고리 리스트 가져오기
const getCategoryList = async () => {
  try {
    const res = await axios.get("/new_api/category/list");
    categoryList.value = res.data.data.categoryList;
  } catch (error) {
    console.error(error);
  }
};

// 서브 카테고리 가져오기
const getSubCategories = async (parentId) => {
  try {
    if (!parentId) return;
    if (lastHoveredCategory.value === parentId) {
      return;
    }
    lastHoveredCategory.value = parentId;

    if (subCategoriesMap.value.has(parentId)) {
      categoryList2.value = subCategoriesMap.value.get(parentId);
      activeCategory.value = parentId;
      return;
    }

    const res = await axios.get(
      `/new_api/category/list/simple?parentId=${parentId}`,
    );
    const subCategories = res.data.data.categoryList;

    subCategoriesMap.value.set(parentId, subCategories);
    categoryList2.value = subCategories;
    activeCategory.value = parentId;
  } catch (err) {
    console.error(err);
  }
};

// 서브 카테고리 숨기기
const hideSubCategories = () => {
  lastHoveredCategory.value = null;
  if (!route.params.category && !route.params.subcategory) {
    activeCategory.value = null;
    categoryList2.value = [];
  } else if (route.params.category) {
    if (subCategoriesMap.value.has(route.params.category)) {
      categoryList2.value = subCategoriesMap.value.get(route.params.category);
      activeCategory.value = route.params.category;
    }
  }
};

// 검색 핸들러
const handleSearch = async (pageNum) => {
  if (!searchQuery.value) {
    alert("검색어를 입력해 주세요.");
    return;
  }

  const queryParams = {
    ...route.query,
    search: searchQuery.value,
  };

  await router.push({
    path: "/mall/hana",
    query: queryParams,
  });
};

// 스크롤 관련 상태 관리
const lastScrollY = ref(0);

// 스크롤 이벤트 핸들러
const handleScroll = () => {
  const currentScrollY = window.scrollY;
  const scrollDirection = currentScrollY > lastScrollY.value ? "down" : "up";

  if (scrollDirection === "up" && headerRef.value?.shopTopMenuRef) {
    const shopTopMenuRef = headerRef.value.shopTopMenuRef;
    shopTopMenuRef.style.transitionDelay = "0.25s";
    shopTopMenuRef.style.top = `${navHeight.value}px`;
    shopTopMenuRef.style.transition = "top 1s";
    shopTopMenuRef.style.transitionDelay = "0.25s";
  } else if (scrollDirection === "down" && headerRef.value?.shopTopMenuRef) {
    const shopTopMenuRef = headerRef.value.shopTopMenuRef;
    shopTopMenuRef.style.transition = "top 0.7s";
    shopTopMenuRef.style.transitionDelay = "0s";
    shopTopMenuRef.style.top = "0";
  }

  lastScrollY.value = currentScrollY;
};

// nav_container 높이 가져오기
const getNavHeight = () => {
  const navHeightVar = getComputedStyle(document.documentElement)
    .getPropertyValue("--nav-height")
    .trim();

  if (navHeightVar) {
    navHeight.value = parseInt(navHeightVar.replace("px", "")) || 80;
  } else {
    navHeight.value = 80;
  }
};

const groups = [
  { label: "영유아부", value: "INFANT" },
  { label: "유치부", value: "KINDERGARTEN" },
  { label: "유년부", value: "CHILD" },
  { label: "초등부", value: "ELEMENTARY" },
  { label: "청소년", value: "TEENAGER" },
  { label: "대학 및 청년부", value: "SENIOR" },
  { label: "장년부", value: "ADULT" },
];

const semesters = [
  { label: "1과정1학기", value: "1-1", group: "1" },
  { label: "1과정2학기", value: "1-2", group: "2" },
  { label: "2과정1학기", value: "2-1", group: "1" },
  { label: "2과정2학기", value: "2-2", group: "2" },
  { label: "3과정1학기", value: "3-1", group: "1" },
  { label: "3과정2학기", value: "3-2", group: "2" },
  { label: "4과정1학기", value: "4-1", group: "1" },
  { label: "4과정2학기", value: "4-2", group: "2" },
  { label: "5과정1학기", value: "5-1", group: "1" },
  { label: "5과정2학기", value: "5-2", group: "2" },
  { label: "6과정1학기", value: "6-1", group: "1" },
  { label: "6과정2학기", value: "6-2", group: "2" },
];

const lessons = [
  { label: "1과", value: "1", group: "1" },
  { label: "2과", value: "2", group: "1" },
  { label: "3과", value: "3", group: "1" },
  { label: "4과", value: "4", group: "1" },
  { label: "5과", value: "5", group: "1" },
  { label: "6과", value: "6", group: "1" },
  { label: "7과", value: "7", group: "1" },
  { label: "8과", value: "8", group: "1" },
  { label: "9과", value: "9", group: "1" },
  { label: "10과", value: "10", group: "1" },
  { label: "11과", value: "11", group: "1" },
  { label: "12과", value: "12", group: "1" },
  { label: "13과", value: "13", group: "1" },
  { label: "14과", value: "14", group: "1" },
  { label: "15과", value: "15", group: "1" },
  { label: "16과", value: "16", group: "1" },
  { label: "17과", value: "17", group: "1" },
  { label: "18과", value: "18", group: "1" },
  { label: "19과", value: "19", group: "1" },
  { label: "20과", value: "20", group: "1" },
  { label: "21과", value: "21", group: "1" },
  { label: "22과", value: "22", group: "1" },

  { label: "23과", value: "23", group: "2" },
  { label: "24과", value: "24", group: "2" },
  { label: "25과", value: "25", group: "2" },
  { label: "26과", value: "26", group: "2" },
  { label: "27과", value: "27", group: "2" },
  { label: "28과", value: "28", group: "2" },
  { label: "29과", value: "29", group: "2" },
  { label: "30과", value: "30", group: "2" },
  { label: "31과", value: "31", group: "2" },
  { label: "32과", value: "32", group: "2" },
  { label: "33과", value: "33", group: "2" },
  { label: "34과", value: "34", group: "2" },
  { label: "35과", value: "35", group: "2" },
  { label: "36과", value: "36", group: "2" },
  { label: "37과", value: "37", group: "2" },
  { label: "38과", value: "38", group: "2" },
  { label: "39과", value: "39", group: "2" },
  { label: "40과", value: "40", group: "2" },
  { label: "41과", value: "41", group: "2" },
  { label: "42과", value: "42", group: "2" },
  { label: "43과", value: "43", group: "2" },
  { label: "44과", value: "44", group: "2" },

  { label: "어버이주일", value: "어버이주일", group: "3" },
  { label: "어린이주일", value: "어린이주일", group: "3" },
  { label: "부활주일", value: "부활주일", group: "3" },
  { label: "종려주일", value: "종려주일", group: "3" },
  { label: "성탄주일", value: "성탄주일", group: "3" },
  { label: "추수감사", value: "추수감사", group: "3" },
  { label: "전도선교", value: "전도선교", group: "3" },
  { label: "이단경계", value: "이단경계", group: "3" },
  { label: "이웃사랑", value: "이웃사랑", group: "3" },
  { label: "나라사랑", value: "나라사랑", group: "3" },
  { label: "공통", value: "공통", group: "3" },
];

const filteredLessons = computed(() => {
  const currentSemester = semesters.find(
    (s) => s.value === selectedSemester.value,
  );

  if (!currentSemester) {
    // 학기가 선택되지 않았거나 찾을 수 없는 경우 전체 노출 (또는 정책에 따라 빈 배열)
    // 여기서는 전체 노출로 둡니다.
    return lessons;
  }

  const group = currentSemester.group;

  if (group === "1") {
    return lessons.filter((l) => l.group === "1" || l.group === "3");
  } else if (group === "2") {
    return lessons.filter((l) => l.group === "2" || l.group === "3");
  } else if (group === "3") {
    return lessons.filter((l) => l.group === "3");
  }

  return lessons;
});

const getCategoryLabel = (value) => {
  const category = groups.find((c) => c.value === value);
  return category ? category.label : "";
};

const getSemesterLabel = (value) => {
  const semester = semesters.find((s) => s.value === value);
  return semester ? semester.label : "";
};

const getChapterLabel = (value) => {
  const chapter = lessons.find((c) => c.value === value);
  return chapter ? chapter.label : "";
};

const getNextValue = (list, currentValue, direction) => {
  const currentIndex = list.findIndex((item) => item.value === currentValue);

  // 선택된 값이 목록에 없으면(초기상태 등) 첫 번째 값 반환
  if (currentIndex === -1) return list[0].value;

  // 인덱스 계산 (음수 처리 및 모듈러 연산을 통한 순환)
  // (현재인덱스 + 방향 + 전체길이) % 전체길이
  const nextIndex = (currentIndex + direction + list.length) % list.length;

  return list[nextIndex].value;
};

//이전/다음 버튼 클릭 핸들러
const moveSelection = (direction) => {
  // 1. '과'가 선택되어 있는 경우 -> '과'를 변경
  if (selectedLesson.value) {
    selectedLesson.value = getNextValue(
      filteredLessons.value,
      selectedLesson.value,
      direction,
    );

    // 데이터 변경 후 목록 갱신이 필요하다면 호출 (기존 템플릿에 있던 함수)
    if (typeof handleListChange === "function") handleListChange();
    return;
  }

  // 2. '학기'가 선택되어 있는 경우 -> '학기'를 변경
  if (selectedSemester.value) {
    selectedSemester.value = getNextValue(
      semesters,
      selectedSemester.value,
      direction,
    );

    selectedLesson.value = "";
    if (typeof handleListChange === "function") handleListChange();
    return;
  }

  // 3. '부서'가 선택되어 있는 경우 (혹은 아무것도 없는 경우) -> '부서'를 변경
  // 아무것도 선택 안 된 상태에서 버튼 누르면 첫 부서 혹은 마지막 부서 선택됨
  selectedCategory.value = getNextValue(
    groups,
    selectedCategory.value,
    direction,
  );

  if (typeof handleListChange === "function") handleListChange();
};

const handleSemesterChange = () => {
  selectedLesson.value = "";
  handleListChange();
};

const handleListChange = () => {
  closeDetailModal();
  isDepartmentPopoverOpen.value = false;
  isSemesterPopoverOpen.value = false;
  isChapterPopoverOpen.value = false;
  getContentsList(
    selectedCategory.value,
    selectedSemester.value,
    selectedLesson.value,
  );
};

// 하나 바이블 콘텐츠 리스트 가져오기
const getContentsList = async (group = "", semester = "", lesson = "") => {
  // URL 쿼리 파라미터가 존재하면 해당 값을 우선 사용 (빈 값도 그대로 반영)
  const resolvedGroup = "group" in route.query ? String(route.query.group ?? "") : group;
  const resolvedSemester = "semester" in route.query ? String(route.query.semester ?? "") : semester;
  const resolvedLesson = "lesson" in route.query ? String(route.query.lesson ?? "") : lesson;

  if ("group" in route.query) selectedCategory.value = resolvedGroup;
  if ("semester" in route.query) selectedSemester.value = resolvedSemester;
  if ("lesson" in route.query) selectedLesson.value = resolvedLesson;

  try {
    loading.value = true;
    const apiUrl = `/new_api/customer/item/hana-bible/v1/page?page=${page.value}&size=${size.value}&group=${resolvedGroup}&semester=${resolvedSemester}&lesson=${resolvedLesson}`;

    const { data } = await axios.get(apiUrl);
    contentList.value = data.data.itemList;
    pageInfo.value = data.data.pageInfo;
  } catch (err) {
    console.error(err);
    contentList.value = [];
  } finally {
    loading.value = false;
  }
};

// 하나 바이블 콘텐츠 상세 가져오기
const getContentsDetail = async (contentId) => {
  if (!contentId) {
    return;
  }

  detailError.value = "";
  detailLoading.value = true;
  selectedContentDetail.value = null;

  try {
    const { data } = await axios.get(`/new_api/app_bible/content/${contentId}`);

    console.log(data);
    if (data.data.contentType == "FILE") {
      router.push({ path: "/mall/view/" + data.data.contentId });
      return;
    } else {
      const detail = data?.data?.contentVideoList;
      isDetailModalOpen.value = true;

      if (detail) {
        selectedContentDetail.value = detail;
      } else {
        detailError.value = "비디오 정보를 찾을 수 없습니다.";
      }
    }
  } catch (err) {
    console.error(err);
    detailError.value = "콘텐츠 정보를 불러오지 못했습니다.";
  } finally {
    detailLoading.value = false;
  }
};

const openContentDetail = (content) => {
  const contentId = content?.id;
  if (!contentId) {
    detailError.value = "콘텐츠 ID가 존재하지 않습니다.";
    isDetailModalOpen.value = true;
    return;
  }

  getContentsDetail(contentId);
};

// 부서,학기,과 저장
const putPreference = async () => {
  if (
    selectedCategory.value ||
    selectedSemester.value ||
    selectedLesson.value
  ) {
    const preferenceValue =
      selectedCategory.value +
      ":" +
      selectedSemester.value +
      ":" +
      selectedLesson.value;

    console.log(preferenceValue);

    try {
      axios
        .put("/new_api/account/hana-bible-preference", {
          hanaBiblePreference: preferenceValue,
        })
        .then((res) => {
          console.log(res.data.result);
          alert("설정이 저장되었습니다.");
        });
    } catch (error) {
      console.error(error);
    }
  } else {
    alert("부서, 학기/과정, 과를 선택해 주세요.");
    return;
  }
};

// 부서,학기,과 불러오기
const getPreference = async () => {
  try {
    const res = await axios.get(`/new_api/account/hana-bible-preference`);
    const rawPreference = res.data.data.hanaBiblePreference;

    if (rawPreference) {
      const parts = rawPreference.split(":");

      selectedCategory.value = parts[0] || "";
      selectedSemester.value = parts[1] || "";
      selectedLesson.value = parts[2] || "";
    }

    console.log(res);
  } catch (error) {
    console.error(error);
  }
};

const updatePage = (num) => {
  page.value = num;
  getContentsList();
};

const getVideoInfo = (url) => {
  if (!url) return { type: null };

  const trimmed = url.trim();

  // 1. 비메오 체크
  const vimeoMatch = trimmed.match(/vimeo\.com\/(?:.*\/)?(\d+)/);
  if (vimeoMatch && vimeoMatch[1]) {
    return {
      type: "vimeo",
      id: vimeoMatch[1],
      //embed 주소로 변환
      src: `https://player.vimeo.com/video/${vimeoMatch[1]}`,
    };
  }

  // 2. 유튜브 체크
  const ytMatch =
    trimmed.match(/youtu\.be\/([^?&#]+)/i) ??
    trimmed.match(
      /youtube\.com\/(?:watch\?v=|embed\/|v\/|shorts\/)([^?&#]+)/i,
    ) ??
    trimmed.match(/[?&]v=([^?&#]+)/i);

  if (ytMatch && ytMatch[1]) {
    return {
      type: "youtube",
      id: ytMatch[1],
      //embed 주소로 변환
      src: `https://www.youtube.com/embed/${ytMatch[1]}`,
    };
  }
};

const getGroupedTargets = (list) => {
  if (!list || list.length === 0) return [];

  const groupedMap = list.reduce((acc, item) => {
    if (!acc[item.groupType]) {
      acc[item.groupType] = [];
    }
    acc[item.groupType].push(item.groupNameValue);
    return acc;
  }, {});

  return Object.keys(groupedMap).map((type) => {
    const names = groupedMap[type].join(", "); // 예: "유년부, 초등부"
    let suffix = "";

    if (type === "AGE_GROUP") {
      suffix = " 활동에 좋아요";
    } else if (type === "ROLES") {
      suffix = "님께 추천해요";
    }

    return { names, suffix };
  });
};

const formatKeyword = (item) => {
  if (item.depth1 === item.depth2) {
    return item.depth1;
  }
  return `${item.depth1} ${item.depth2}`;
};

const closeTip = () => {
  isTipVisible.value = false;
  //닫았다는 사실을 저장
  localStorage.setItem("smart_tip_closed", "true");
};

onMounted(async () => {
  getNavHeight();
  window.addEventListener("scroll", handleScroll, { passive: true });
  window.addEventListener("keydown", handleKeyDown);

  await getCategoryList();
  await getPreference();
  await getContentsList(
    selectedCategory.value,
    selectedSemester.value,
    selectedLesson.value,
  );

  if (
    !document.querySelector(
      'script[src="https://player.vimeo.com/api/player.js"]',
    )
  ) {
    const script = document.createElement("script");
    script.src = "https://player.vimeo.com/api/player.js";
    document.head.appendChild(script);
  }

  const hasClosedTip = localStorage.getItem("smart_tip_closed");
  if (!hasClosedTip) {
    setTimeout(() => {
      isTipVisible.value = true;
    }, 500);
  }
});

onUnmounted(() => {
  window.removeEventListener("scroll", handleScroll);
  window.removeEventListener("keydown", handleKeyDown);
});

// route의 category 파라미터가 변경될 때 selectedCategoryId를 동기화
watchEffect(() => {
  if (route.params.category) {
    selectedCategoryId.value = route.params.category;
  }
});
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease, transform 0.6s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
  transform: translateY(10px);
}
</style>
